'use client'

import React from 'react'

import NarrativeHero, { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'
import Spacer from 'lib/components/Spacer/Spacer'

interface NarrativePageProps {
  hero: NarrativeHeroProps
  children?: React.ReactNode
}

const NarrativePage: React.FC<NarrativePageProps> = ({ hero, children }) => {
  return (
    <div className="w-full items-center">
      <div className="pt-10 sm:px-0 sm:pt-0 md:px-[40px] lg:px-[64px] lg:pt-20">
        <NarrativeHero {...hero} />
      </div>
      <Spacer />
      {children}
    </div>
  )
}

export default NarrativePage
